import { addGAEventTracking } from '!/common/helpers';
import { PureComponent } from 'react';
import { getLocale } from '!/common/helpers';

class WidgetToggleMore extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: true
    };
  }

  onClick = event => {
    event.preventDefault();

    this.setState({ collapsed: !this.state.collapsed });
    this.props.toggle();
  };

  render() {
    const { title } = this.props;
    let label = this.state.collapsed ? 'More' : 'Less';
    return (
      <button
        className="btn btn--small btn--outline mbdbl widget__show-more"
        onClick={this.onClick}
        {...addGAEventTracking(`See ${label}`, 'Search Filter', title)}
      >
        {getLocale(`Show ${label} Options`)}
      </button>
    );
  }
}

export default WidgetToggleMore;
